import { useCallback, useContext, useEffect } from 'react';
import { AppStateContext } from '../contexts/AppStateContext';
import { LicensesContext } from '../contexts/LicensesContext';
import apiEndpoint from '../../utils/apiEndpoint';
import axios from 'axios';
import { createMasterLicense, filterValidLicenses } from './licenseUtils';

const needsFetchLicense = (license) => {
  if (license) {
    const licenseAsDate = new Date(license);
    // eslint-disable-next-line
    if (licenseAsDate != 'Invalid Date') {
      return licenseAsDate <= new Date();
    }
    return license !== 'invalid';
  }
  return true;
};

const LicenseChecker = (props) => {
  const { online } = props;
  const [appState, setAppState] = useContext(AppStateContext);
  const [, setLicenses] = useContext(LicensesContext);
  const { isLoggedIn, expires, isLicenseActivated } = appState;

  const getLicenses = useCallback(async () => {
    await axios
      .get(`${apiEndpoint}/api/licenses/`)
      .then((response) => {
        if (response.data) {
          const validLicenses = filterValidLicenses(response.data);
          const isValidLicense = validLicenses.length > 0;
          const masterLicense = createMasterLicense(validLicenses);

          if (!masterLicense) {
            console.log('No valid licenses found');
            window.localStorage.setItem('license', 'invalid');
            setAppState((state) => ({
              ...state,
              isValidLicense: false,
              licensesChecked: true,
              isLoading: false,
              expires: new Date(),
            }));
            return;
          }

          const unlockedContent = {
            summa_arvotaulukot: masterLicense.meta?.summa_arvotaulukot ?? false,
            maastotaulukot: masterLicense.meta?.maastotaulukot === false ? false : true, //default to true if this doesn't exist
          };

          window.localStorage.setItem(
            'license',
            isValidLicense ? masterLicense.expires : 'invalid'
          );
          window.localStorage.setItem(
            'licenseType',
            masterLicense.type,
          );
          window.localStorage.setItem('unlockedContent', JSON.stringify(unlockedContent));

          setLicenses(response.data);

          if (masterLicense.expires !== expires) {
            setAppState((state) => {
              return {
                ...state,
                isValidLicense,
                licensesChecked: true,
                licenseType: masterLicense.type,
                unlockedContent,
                isLoading: false,
                expires: masterLicense.expires,
              };
            });
          } else {
            setAppState((state) => {
              return {
                ...state,
                licensesChecked: true,
                isLoading: false,
              };
            });
          }
        } else {
          console.log('No licence data received');
          window.localStorage.setItem('license', 'invalid');
          setAppState((state) => {
            return {
              ...state,
              isValidLicense: false,
              licensesChecked: true,
              isLoading: false,
              expires: new Date(),
            };
          });
        }
      })
      .catch((err) => {
        console.log('license error: ', err);
        window.localStorage.setItem('license', 'invalid');
        setAppState((state) => {
          return {
            ...state,
            isValidLicense: false,
            licensesChecked: true,
            expires: new Date(),
          };
        });
      });
  }, [setLicenses, expires, setAppState]);

  useEffect(() => {
    const license = window.localStorage.getItem('license');

    if (online && isLoggedIn && needsFetchLicense(license)) {
      getLicenses();
    } else if (isLoggedIn && license && expires !== license && license !== 'invalid') {
      const storedUnlockedContent = window.localStorage.getItem('unlockedContent');
      setAppState((state) => {
        return {
          ...state,
          isValidLicense: new Date(license) >= new Date() ? true : false,
          licensesChecked: true,
          licenseType: window.localStorage.getItem('licenseType'),
          unlockedContent: storedUnlockedContent ? JSON.parse(storedUnlockedContent) : state.unlockedContent,
          expires: license,
        };
      });
    }
  }, [isLoggedIn, expires, getLicenses, online, isLicenseActivated, setAppState]);

  return null;
};

export default LicenseChecker;
